import React, { Component } from "react";
import SentMessagesRowRO from "./SentMessageRowRO";

class GolfMessageTable extends Component {
  state = { sentmessages: "None" };
  _makeRemoteRequest = () => {
    fetch("/sentmessages")
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        this.setState({ sentmessages: data.sentmessages });
      });
  };
  componentDidMount() {
    this._makeRemoteRequest();
  }
  render() {
    if (this.state.sentmessages === "None") return "No Messages today";
    let today = new Date();

    return (
      <div>
        <table className="table table-striped table-sm">
          <thead className="thead-dark">
            <tr>
              <th>Date</th>
              <th>Time (UTC)</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {this.state.sentmessages.map(sentmessage => {
              let mDate = new Date(sentmessage[0]);
              if (
                today.getDate() === mDate.getDate() &&
                today.getMonth() === mDate.getMonth() &&
                today.getFullYear() === mDate.getFullYear()
              )
                return (
                  <SentMessagesRowRO
                    key={sentmessage}
                    sentmessage={sentmessage}
                  />
                );
              return null;
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default GolfMessageTable;
